


























































































import {
  createOrUpdateAgencyPrice,
  createOrUpdateSharedProduct,
} from '@/api/Topup/topup.api'
import { AgencyTopUpPrice } from '@/utils/interfaces/topup.interface'
import { number } from '@/utils/validators'
import { tableHandler } from '@/utils/mixins/tableHandler'
import { Paginator, VueTable } from '@/utils/interfaces'
import AgencyPricesDialog from '@/components/Services/TopUps/AgencyPricesDialog.vue'
import ActionButton from '@/components/ActionButton.vue'
import ProductDistribution from '@/components/Services/TopUps/ProductDistribution.vue'
import { AxiosResponse } from 'axios'
import { getAgencyProducts, getAgencySharedProducts } from '@/utils/functions'
import FlatCard from '~/components/FlatCard.vue'
import TextButton from '~/components/TextButton.vue'

export default tableHandler<AgencyTopUpPrice>().extend({
  components: {
    appAgencyPricesDialog: AgencyPricesDialog,
    appActionButton: ActionButton,
    appProductDistribution: ProductDistribution,
    FlatCard,
    TextButton,
  },
  data() {
    return {
      search: '',
      tabs: 0,
      prices: null as null | AgencyTopUpPrice,
      loading: false,
      rules: {
        numeric: (value: string) =>
          number(value) || this.$t('validation.must-be-a-number'),
        greaterThan: (value: number) =>
          value > 0 ||
          this.$t('validation.must-be-greater-than-equal', { value: 0 }),
      },
      changingItem: null as null | AgencyTopUpPrice,
      items: [] as AgencyTopUpPrice[],
      sharedItems: [] as AgencyTopUpPrice[],
    }
  },
  computed: {
    headers() {
      const headers = [
        {
          text: this.$t('provider'),
          value: 'provider_name',
        },
        {
          text: this.$t('parent_provider'),
          value: 'shared_provider_parent',
        },
        {
          text: this.$t('agency.agency'),
          value: 'agency_name',
        },
        {
          text: this.$t('product'),
          value: 'product_name',
        },
        {
          text: this.$t('price'),
          value: 'price',
        },
        {
          text: this.$t('active'),
          value: 'is_active',
        },
        {
          text: this.$t('use-rate'),
          value: 'rate',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ]
      if (!this.tabs) {
        headers.splice(1, 1)
      }
      return headers
    },
    computedItems(): AgencyTopUpPrice[] {
      const criteria = this.search?.toLowerCase() || ''

      const filter = (
        item: AgencyTopUpPrice & {
          shared_provider_name?: string
          product_name?: string
        },
      ) =>
        item.price.toString().includes(criteria) ||
        item.agency_name.toLowerCase().includes(criteria) ||
        item.product_name?.toLowerCase().includes(criteria) ||
        item.provider_name?.toLowerCase().includes(criteria) ||
        item.shared_provider_name?.toLowerCase().includes(criteria)

      if (this.tabs === 1) {
        return this.sharedItems.filter(filter)
      }
      return this.items.filter(filter)
    },
    isDark(): boolean {
      return this.$vuetify.theme.dark
    },
    shared(): boolean {
      return !!this.tabs
    },
    getter(): () => Promise<AxiosResponse<Paginator<AgencyTopUpPrice>>> {
      if (this.tabs === 1) {
        return getAgencySharedProducts
      } else return getAgencyProducts
    },
    table(): VueTable {
      const tables = this.$refs.table as VueTable[]
      if (tables && tables[this.tabs]) {
        return tables[this.tabs]
      } else return {} as VueTable
    },
  },
  methods: {
    onNew(item: AgencyTopUpPrice) {
      this.computedItems.push(item)
    },
    async onChange(item: AgencyTopUpPrice) {
      try {
        this.changingItem = item
        if (item.provider_name) {
          await createOrUpdateAgencyPrice({
            is_active: item.is_active,
            uuid: item.uuid,
          })
        } else {
          await createOrUpdateSharedProduct({
            is_active: item.is_active,
            uuid: item.uuid,
          })
        }
      } catch {
        item.is_active = !item.is_active
      } finally {
        this.changingItem = null
      }
    },
    fetchProducts() {
      this.loading = true
      getAgencySharedProducts({ limit: 1000 }).then(response => {
        this.sharedItems = response.data.results
      })
      getAgencyProducts({ limit: 1000 })
        .then(response => {
          this.items = response.data.results
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
  mounted() {
    this.fetchProducts()
  },
})
